import styled from 'styled-components';
import { Theme } from '@/theme';

export const PopupContent = styled.div`
  background: ${Theme.color.white};
  position: relative;
  width: 100%;
`;

export const Title = styled.h1`
  color: ${Theme.color.darkGrey};
  font-family: ${Theme.font.family.speedeeCondensed};
  font-size: ${Theme.rems(40)};
  font-weight: ${Theme.font.weight.bold};
  line-height: 0.95;
  margin: 0 0 12px;
  text-align: center;
  text-transform: uppercase;
`;

export const Description = styled.p`
  color: ${Theme.color.darkGrey};
  font-family: ${Theme.font.family.speedee};
  font-size: ${Theme.rems(16)};
  line-height: 1.28;
  margin: 0 auto 24px;
  text-align: center;
`;

export const FieldGroup = styled.div`
  margin-bottom: 22px;
`;

export const FieldLabel = styled.label`
  color: ${Theme.color.darkGrey};
  display: block;
  font-family: ${Theme.font.family.speedee};
  font-size: ${Theme.rems(16)};
  line-height: 1.1;
  margin-bottom: 8px;
`;

export const Stepper = styled.div`
  align-items: center;
  border: 2px solid #9c9c9c;
  border-radius: 27px;
  display: grid;
  gap: 10px;
  grid-template-columns: 40px 1fr 40px;
  height: 54px;
  padding: 5px;
  width: 100%;
`;

export const StepperButton = styled.button`
  align-items: center;
  background-image: radial-gradient(
    50% 50% at 50% 50%,
    #ea282e 0%,
    #b80a0a 100%
  );
  border: none;
  border-radius: 50%;
  box-shadow: 0 2px 0 0 rgb(0 0 0 / 0.3) inset;
  color: ${Theme.color.orange};
  cursor: pointer;
  display: flex;
  font-family: ${Theme.font.family.speedee};
  font-size: ${Theme.rems(40)};
  font-weight: ${Theme.font.weight.bold};
  height: 40px;
  justify-content: center;
  line-height: 1;
  width: 40px;

  &:disabled {
    background: ${Theme.color.lightGrey};
    box-shadow: none;
    color: #a6a6a6;
    cursor: default;
  }
`;

export const StepperValue = styled.span`
  color: #595959;
  font-family: ${Theme.font.family.speedeeCondensed};
  font-size: ${Theme.rems(32)};
  font-weight: ${Theme.font.weight.bold};
  line-height: 1;
  text-align: center;
`;

export const Note = styled.div`
  align-items: center;
  background: #fff4d6;
  border-radius: 10px;
  color: ${Theme.color.darkGrey};
  display: flex;
  font-family: ${Theme.font.family.speedee};
  font-size: ${Theme.rems(14)};
  gap: 12px;
  line-height: 1.32;
  margin: -8px 0 18px;
  min-height: 47px;
  padding: 8px 16px 8px 52px;
  position: relative;
`;

export const NoteIcon = styled.span`
  display: block;
  height: 30px;
  left: 12px;
  position: absolute;
  top: 8px;
  width: 30px;

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`;

export const DateFields = styled.div`
  display: grid;
  gap: 12px;
  margin-bottom: 14px;
`;

export const DateRow = styled.div`
  align-items: end;
  display: grid;
  gap: 13px;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 25px;
`;

export const DateSelect = styled.label`
  align-items: center;
  border: 1px solid ${Theme.color.orange};
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  font-family: ${Theme.font.family.speedee};
  font-size: ${Theme.rems(14)};
  font-style: normal;
  font-weight: 400;
  height: 36px;
  justify-content: space-between;
  padding: 0 11px;
  position: relative;
  width: 100%;

  span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  svg {
    flex: 0 0 auto;
    margin-left: 8px;
  }
`;

export const DateInput = styled.select`
  appearance: none;
  border: none;
  cursor: pointer;
  inset: 0;
  opacity: 0;
  position: absolute;
  width: 100%;
`;

export const DateColumn = styled.div`
  min-width: 0;
`;

export const DateLabel = styled.label`
  color: ${Theme.color.darkGrey};
  display: block;
  font-family: ${Theme.font.family.speedee};
  font-size: ${Theme.rems(14)};
  line-height: 1;
  margin-bottom: 9px;
`;

export const DeleteDateButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  color: #444;
  cursor: pointer;
  display: flex;
  height: 36px;
  justify-content: center;
  padding: 0;
  width: 25px;

  svg {
    height: 24px;
    width: 24px;
  }
`;

export const Button = styled.button`
  align-items: center;
  background: ${Theme.color.orange};
  border: none;
  border-radius: 999px;
  color: ${Theme.color.black};
  cursor: pointer;
  display: flex;
  font-family: ${Theme.font.family.speedeeCondensed};
  font-size: ${Theme.rems(22)};
  font-weight: ${Theme.font.weight.bold};
  gap: 14px;
  height: 60px;
  justify-content: center;
  margin: 14px auto 0;
  max-width: 100%;
  text-transform: uppercase;
  width: 200px;
`;

export const Arrow = styled.span`
  border-top: 3px solid ${Theme.color.black};
  display: block;
  height: 0;
  position: relative;
  width: 28px;

  &::before,
  &::after {
    border-top: 3px solid ${Theme.color.black};
    content: '';
    position: absolute;
    right: -1px;
    top: -3px;
    transform-origin: right center;
    width: 14px;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;
